import Login from "../pages/Login";
import Sites from "../pages/Sites";
import Site from "../pages/Site";
import Dashboard from "../pages/Dashboard";

export const LOGIN_ROUTE = {
  path: "/login",
  Component: Login,
};

export const DASHBOARD_ROUTE = {
  path: "/site/:siteId/:categoryId",
  Component: Dashboard,
  needAuth: true,
  computePath: ({siteId, categoryId}) => `/site/${siteId}/${categoryId}`
};

export const SITE_ROUTE = {
  path: "/site/:siteId",
  Component: Site,
  needAuth: true,
  computePath: ({siteId}) => `/site/${siteId}`
};

export const SITES_ROUTE = {
  path: "/",
  Component: Sites,
  needAuth: true,
};

const routes = [
  LOGIN_ROUTE,
  DASHBOARD_ROUTE,
  SITE_ROUTE,
  SITES_ROUTE,
];

export default routes;
